import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function TaxCollectorModal({ show, handleClose, onSave, data }) {
  const [formData, setFormData] = useState({
    tax_date: "",
    tax_amount: "",
    tax_type: "offline",
  });
  const [loading, setLoading] = useState(false);
  const isEditMode = !!data;

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (data) {
      setFormData({
        tax_date: data.tax_date,
        tax_amount: data.tax_amount,
        tax_type: data.tax_type,
      });
    } else {
      setFormData({
        tax_date: new Date().toISOString().split("T")[0],
        tax_amount: "",
        tax_type: "offline",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const endpoint = isEditMode
      ? "/tax-department-update.php"
      : "/add-tax-department.php";

    // **FIXED PAYLOAD**
    const payload = isEditMode ? { ...formData, tax_id: data.id } : formData;

    try {
      const response = await axios.post(`${API_URL}${endpoint}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        toast.success(
          `Tax record ${isEditMode ? "updated" : "added"} successfully!`
        );
        onSave();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEditMode ? "Edit" : "Add"} Tax Entry</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Collection Date</Form.Label>
            <Form.Control
              type="date"
              name="tax_date"
              value={formData.tax_date}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              name="tax_amount"
              value={formData.tax_amount}
              onChange={handleChange}
              required
              placeholder="Enter tax amount"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Payment Type</Form.Label>
            <Form.Select
              name="tax_type"
              value={formData.tax_type}
              onChange={handleChange}
            >
              <option value="offline">Offline</option>
              <option value="online">Online</option>
              <option value="cash">Cash</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Save"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default TaxCollectorModal;
